import { intersection } from 'lodash'
import { TCountryCode, IState, REGIONS, BOOKING_REGIONS, STATES } from 'constants/countriesStates'
import { TSelectOpt } from '../transfix-ui/components/Select/SelectTypes'

export const mapRegionsToStateCode = (stateCode: string | string[]): string | string[] => {
  const regionCodes = REGIONS.map(region => region.abbr)
  if (Array.isArray(stateCode)) {
    if (intersection(stateCode, regionCodes).length === 0) {
      return stateCode
    }
  } else if (regionCodes.indexOf(stateCode) === -1) {
    return stateCode
  }

  const selectedRegion = REGIONS.filter(region => region.abbr === stateCode)[0].statesArray
  return selectedRegion
}

export const mapRegionsToFilterAbbreviations = (stateCode: string): string | string[] => {
  const mappedRegions = BOOKING_REGIONS.find(region => region.abbr === stateCode)
  return mappedRegions ? mappedRegions.regionsArray : stateCode
}

export const mapRegionAbbrToName = (abbr: string): string | undefined => {
  const region = REGIONS.find(region => region.abbr === abbr)
  return region?.name || undefined
}

export const mapStateAbbrToName = (abbr: string = ''): string | undefined => {
  const state = [...STATES.US, ...STATES.CA].find(state => state.abbr === abbr)
  return state?.name || undefined
}

export const mapStateNameToAbbr = (name: string = ''): string | undefined => {
  const state = [...STATES.US, ...STATES.CA].find(state => state.name === name)
  return state?.abbr || undefined
}

/**
 * Return all the IState for a given country
 * @param {TCountryCode} country 'US' | 'CA'
 * @returns {IState[]} array of IState
 */
export const getStates = (country: TCountryCode): IState[] => {
  return STATES[country]
}

/**
 * Helper function that return the TSelectOpt[] of states
 * for a given country
 * @param {TCountryCode} country 'US' | 'CA'
 * @returns {TSelectOpt[]} options
 * @example
 * ```
 * const statesOptions = getStateSelectOptions('US') // [{value: 'NY', label: 'New York'}, ...]
 * ```
 */
export const getStateSelectOptions = (country: TCountryCode): TSelectOpt[] => {
  return getStates(country).map(s => ({ value: s.abbr, label: s.name }))
}
